var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradesB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9988 6.00024V12.0002M20.4188 6.92224C20.5978 6.84326 20.7498 6.7135 20.8558 6.54904C20.9617 6.38457 21.0172 6.19263 21.0151 5.99697C21.0131 5.80132 20.9537 5.61056 20.8444 5.44832C20.735 5.28608 20.5804 5.15949 20.3998 5.08423L11.8288 1.18023C11.5683 1.06138 11.2852 0.999878 10.9988 0.999878C10.7124 0.999878 10.4294 1.06138 10.1688 1.18023L1.59882 5.08024C1.42079 5.15821 1.26934 5.28637 1.16299 5.44905C1.05664 5.61173 1 5.80188 1 5.99624C1 6.19059 1.05664 6.38074 1.16299 6.54342C1.26934 6.7061 1.42079 6.83426 1.59882 6.91223L10.1688 10.8202C10.4294 10.9391 10.7124 11.0006 10.9988 11.0006C11.2852 11.0006 11.5683 10.9391 11.8288 10.8202L20.4188 6.92224Z",
    stroke: "#23272E",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99902 8.50024V12.0002C4.99902 12.7959 5.63116 13.559 6.75638 14.1216C7.8816 14.6842 9.40772 15.0002 10.999 15.0002C12.5903 15.0002 14.1164 14.6842 15.2417 14.1216C16.3669 13.559 16.999 12.7959 16.999 12.0002V8.50024",
    stroke: "#23272E",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradesB);
export default __webpack_public_path__ + "static/media/GradesB.cc74f5c25dcd4a1ce897da03b2175b5a.svg";
export { ForwardRef as ReactComponent };